module.exports = __webpack_public_path__ + "img/signature_cl.8404aad7.png";